module.exports = __webpack_public_path__ + "img/4.18cc5e91.png";